import React, { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [companyName, setCompanyName] = useState(() => {
    return localStorage.getItem('companyName') || 'RATING';
  });

  const [companyLogo, setCompanyLogo] = useState(() => {
    return localStorage.getItem('companyLogo') || '';
  });

  const [instagramUsername, setInstagramUsername] = useState(() => {
    return localStorage.getItem('instagramUsername') || '';
  });

  const [instagramPassword, setInstagramPassword] = useState(() => {
    return localStorage.getItem('instagramPassword') || '';
  });

  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    safeLocalStorageSet('companyName', companyName);
  }, [companyName]);

  useEffect(() => {
    safeLocalStorageSet('companyLogo', companyLogo);
  }, [companyLogo]);

  useEffect(() => {
    safeLocalStorageSet('instagramUsername', instagramUsername);
  }, [instagramUsername]);

  useEffect(() => {
    safeLocalStorageSet('instagramPassword', instagramPassword);
  }, [instagramPassword]);

  useEffect(() => {
    safeLocalStorageSet('darkMode', JSON.stringify(darkMode));
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  const handleLogoUpload = (file) => {
    return new Promise((resolve, reject) => {
      // Validar tamanho do arquivo (max 5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB em bytes
      if (file.size > maxSize) {
        reject(new Error('A imagem da logo não pode exceder 5MB. Por favor, selecione uma imagem menor.'));
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setCompanyLogo(reader.result);
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  // Função segura para salvar no localStorage com tratamento de QuotaExceededError
  const safeLocalStorageSet = (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      if (error.name === 'QuotaExceededError') {
        console.warn('QuotaExceededError detectado. Limpando cache corrompido...');
        // Limpar todo o localStorage para evitar tela vermelha
        localStorage.clear();
        // Tentar salvar novamente após limpeza
        try {
          localStorage.setItem(key, value);
          console.log('Cache limpo e valor salvo com sucesso.');
        } catch (retryError) {
          console.error('Erro ao salvar mesmo após limpeza do cache:', retryError);
        }
      } else {
        console.error('Erro ao salvar no localStorage:', error);
      }
    }
  };

  const value = {
    companyName,
    setCompanyName,
    companyLogo,
    setCompanyLogo,
    handleLogoUpload,
    instagramUsername,
    setInstagramUsername,
    instagramPassword,
    setInstagramPassword,
    darkMode,
    setDarkMode,
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
